export const AtlassianDataLakeLogoBrand = () => (
  <svg
    width="501"
    height="48"
    viewBox="0 0 501 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_2189_2689)">
      <path
        d="M106.72 18.3604C106.72 22.5604 108.67 25.9004 116.29 27.3704C120.84 28.3204 121.79 29.0604 121.79 30.5704C121.79 32.0804 120.84 33.0004 117.63 33.0004C113.91 33.0004 109.49 31.7404 106.59 30.0104V36.8504C108.89 37.9804 111.92 39.2304 117.55 39.2304C125.52 39.2304 128.68 35.6804 128.68 30.3904M128.68 30.3904C128.68 25.4104 126.04 23.0704 118.59 21.4704C114.48 20.5604 113.48 19.6504 113.48 18.3504C113.48 16.7004 114.95 16.0104 117.68 16.0104C120.97 16.0104 124.22 17.0104 127.29 18.3904V11.8504C125.12 10.7704 121.79 9.90039 117.89 9.90039C110.53 9.90039 106.72 13.1004 106.72 18.3504"
        fill="#0050D3"
      />
      <path
        d="M209.1 10.3506V38.8006H215.16V17.1006L217.72 22.8606L226.29 38.8006H233.92V10.3506H227.85V28.7106L225.56 23.3806L218.67 10.3506H209.1Z"
        fill="#0050D3"
      />
      <path d="M170.54 10.3506H163.91V38.8006H170.54V10.3506Z" fill="#0050D3" />
      <path
        d="M156.26 30.4002C156.26 25.4202 153.62 23.0802 146.17 21.4802C142.06 20.5702 141.06 19.6602 141.06 18.3602C141.06 16.7102 142.53 16.0202 145.26 16.0202C148.55 16.0202 151.8 17.0202 154.87 18.4002V11.8602C152.7 10.7802 149.37 9.91016 145.47 9.91016C138.11 9.91016 134.3 13.1102 134.3 18.3602C134.3 22.5602 136.25 25.9002 143.87 27.3702C148.42 28.3202 149.37 29.0602 149.37 30.5702C149.37 32.0802 148.42 33.0002 145.21 33.0002C141.49 33.0002 137.07 31.7402 134.17 30.0102V36.8502C136.47 37.9802 139.5 39.2302 145.13 39.2302C153.1 39.2302 156.26 35.6802 156.26 30.3902"
        fill="#0050D3"
      />
      <path
        d="M55.24 10.3506V38.8006H68.86L71.01 32.6506H61.91V10.3506H55.24Z"
        fill="#0050D3"
      />
      <path
        d="M28.33 10.3506V16.5006H35.7V38.8006H42.37V16.5006H50.25V10.3506H28.33Z"
        fill="#0050D3"
      />
      <path
        d="M18.66 10.3506H9.92L0 38.8006H7.58L8.99 34.0106C10.67 34.5006 12.45 34.7706 14.3 34.7706C16.15 34.7706 17.92 34.5006 19.61 34.0106L21.02 38.8006H28.6L18.66 10.3506ZM14.29 28.8806C13.02 28.8806 11.8 28.6906 10.64 28.3606L14.29 15.9406L17.94 28.3606C16.78 28.7006 15.56 28.8806 14.29 28.8806Z"
        fill="#0050D3"
      />
      <path
        d="M92.34 10.3506H83.6001L73.6801 38.8006H81.2601L82.6701 34.0106C84.3501 34.5006 86.1301 34.7706 87.9801 34.7706C89.8301 34.7706 91.6001 34.5006 93.2901 34.0106L94.7001 38.8006H102.28L92.3601 10.3506H92.34ZM87.9701 28.8806C86.7001 28.8806 85.4801 28.6906 84.3201 28.3606L87.9701 15.9406L91.6201 28.3606C90.4601 28.7006 89.2401 28.8806 87.9701 28.8806Z"
        fill="#0050D3"
      />
      <path
        d="M194.41 10.3506H185.67L175.75 38.8006H183.33L184.74 34.0106C186.42 34.5006 188.2 34.7706 190.05 34.7706C191.9 34.7706 193.67 34.5006 195.36 34.0106L196.77 38.8006H204.35L194.43 10.3506H194.41ZM190.04 28.8806C188.77 28.8806 187.55 28.6906 186.39 28.3606L190.04 15.9406L193.69 28.3606C192.53 28.7006 191.31 28.8806 190.04 28.8806Z"
        fill="#0050D3"
      />
      <path
        d="M252.15 8.57031H263.28C273.08 8.57031 277.82 14.6903 277.82 23.7503C277.82 32.8103 273.04 38.7903 263.28 38.7903H252.15V8.57031ZM256.29 12.5303V34.8403H263.33C270.23 34.8403 273.68 31.2103 273.68 23.8903C273.68 16.5703 270.41 12.5303 263.1 12.5303H256.29Z"
        fill="#172B4D"
      />
      <path
        d="M298.25 34.6603C296.78 37.7003 294.02 39.2603 290.48 39.2603C284.36 39.2603 281.28 34.0603 281.28 27.3003C281.28 20.5403 284.5 15.3403 290.94 15.3403C294.3 15.3403 296.87 16.8603 298.25 19.8503V15.8003H302.21V38.8003H298.25V34.6603ZM291.53 35.5803C295.07 35.5803 298.25 33.3303 298.25 28.2203V26.3803C298.25 21.2703 295.35 19.0203 291.99 19.0203C287.53 19.0203 285.23 21.9603 285.23 27.3003C285.23 32.6403 287.44 35.5803 291.53 35.5803Z"
        fill="#172B4D"
      />
      <path
        d="M317.29 35.0704C318.21 35.0704 319.08 34.8904 319.77 34.7504V38.5704C319.08 38.7504 318.3 38.9404 317.1 38.9404C312.18 38.9404 309.79 36.0404 309.79 31.7604V19.4804H306.06V15.8004H309.79V10.9204H313.65V15.8004H319.77V19.4804H313.65V31.6704C313.65 33.6904 314.85 35.0704 317.28 35.0704H317.29Z"
        fill="#172B4D"
      />
      <path
        d="M339.51 34.6603C338.04 37.7003 335.28 39.2603 331.74 39.2603C325.62 39.2603 322.54 34.0603 322.54 27.3003C322.54 20.5403 325.76 15.3403 332.2 15.3403C335.56 15.3403 338.13 16.8603 339.51 19.8503V15.8003H343.47V38.8003H339.51V34.6603ZM332.79 35.5803C336.33 35.5803 339.51 33.3303 339.51 28.2203V26.3803C339.51 21.2703 336.61 19.0203 333.25 19.0203C328.79 19.0203 326.49 21.9603 326.49 27.3003C326.49 32.6403 328.7 35.5803 332.79 35.5803Z"
        fill="#172B4D"
      />
      <path
        d="M362.28 8.57031V34.8403H375.99V38.8003H358.14V8.57031H362.28Z"
        fill="#172B4D"
      />
      <path
        d="M394.39 34.6603C392.92 37.7003 390.16 39.2603 386.62 39.2603C380.5 39.2603 377.42 34.0603 377.42 27.3003C377.42 20.5403 380.64 15.3403 387.08 15.3403C390.44 15.3403 393.01 16.8603 394.39 19.8503V15.8003H398.35V38.8003H394.39V34.6603ZM387.67 35.5803C391.21 35.5803 394.39 33.3303 394.39 28.2203V26.3803C394.39 21.2703 391.49 19.0203 388.13 19.0203C383.67 19.0203 381.37 21.9603 381.37 27.3003C381.37 32.6403 383.58 35.5803 387.67 35.5803Z"
        fill="#172B4D"
      />
      <path
        d="M404.32 38.8002V6.18018H408.28V26.5602L418.17 15.7902H423.32L412.51 27.1102L423.78 38.8002H418.4L408.28 28.0302V38.8002H404.32Z"
        fill="#172B4D"
      />
      <path
        d="M436.89 39.2601C428.29 39.2601 424.51 34.2901 424.51 27.2501C424.51 20.2101 428.37 15.3301 435.37 15.3301C442.37 15.3301 445.31 20.2501 445.31 27.2501V29.0401H428.52C429.07 32.9501 431.6 35.4801 437.03 35.4801C439.7 35.4801 441.95 34.9701 444.02 34.2401V37.8701C442.13 38.8801 439.24 39.2501 436.89 39.2501V39.2601ZM428.47 25.6401H441.31C441.08 21.3601 439.15 18.9201 435.19 18.9201C431 18.9201 428.89 21.6301 428.47 25.6401Z"
        fill="#172B4D"
      />
      <path
        d="M490.8 40.6006C488.48 40.6006 486.22 39.5506 484.43 37.6406C483.02 36.1306 481.9 35.9306 481 35.9306C480.1 35.9306 478.98 36.1306 477.57 37.6406C475.73 39.6006 473.38 40.6706 471.03 40.6006C468.78 40.5506 466.65 39.4806 465.04 37.6006C464.09 36.4906 463.43 36.3706 463.01 36.3706H461.51V32.7706H463.01C464.76 32.7706 466.36 33.6106 467.78 35.2606C468.73 36.3706 469.88 36.9706 471.12 37.0006C471.15 37.0006 471.18 37.0006 471.21 37.0006C472.53 37.0006 473.85 36.3606 474.96 35.1806C476.75 33.2606 478.74 32.3306 481.02 32.3306C483.3 32.3306 485.29 33.2606 487.08 35.1806C488.21 36.3806 489.5 37.0606 490.92 37.0006C492.15 36.9706 493.3 36.3706 494.25 35.2606C495.67 33.6106 497.27 32.7706 499.02 32.7706H500.52V36.3706H499.02C498.6 36.3706 497.93 36.5006 496.99 37.6006C495.38 39.4806 493.25 40.5506 491 40.6006C490.94 40.6006 490.88 40.6006 490.83 40.6006H490.8Z"
        fill="#4382F7"
      />
      <path
        d="M491.64 31.8705H489.84V13.2905H493.44V27.0505C493.44 27.0505 493.53 26.9605 493.58 26.9205C494.88 25.7105 496.5 24.2005 499 24.2005H500.5V27.8005H499C497.99 27.8005 497.2 28.4605 496.03 29.5505C494.87 30.6305 493.55 31.8605 491.64 31.8605V31.8705Z"
        fill="url(#paint0_linear_2189_2689)"
      />
      <path
        d="M470.36 31.8705H472.16V13.2905H468.56V27.0505C468.51 27.0105 468.47 26.9605 468.42 26.9205C467.12 25.7105 465.5 24.2005 463 24.2005H461.5V27.8005H463C464.01 27.8005 464.8 28.4605 465.97 29.5505C467.13 30.6305 468.45 31.8605 470.36 31.8605V31.8705Z"
        fill="url(#paint1_linear_2189_2689)"
      />
      <path
        d="M481 19.1804C475.01 19.1804 468.56 17.3404 468.56 13.2904C468.56 9.24039 475.01 7.40039 481 7.40039C486.99 7.40039 493.44 9.24039 493.44 13.2904C493.44 17.3404 486.99 19.1804 481 19.1804ZM481 11.0004C475.42 11.0004 472.37 12.6904 472.16 13.3304C472.37 13.8904 475.42 15.5804 481 15.5804C486.58 15.5804 489.63 13.8904 489.84 13.2504C489.63 12.6904 486.58 11.0004 481 11.0004Z"
        fill="#4382F7"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2189_2689"
        x1="495.76"
        y1="18.0805"
        x2="492.39"
        y2="32.2005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A82F6" />
        <stop offset="1" stopColor="#2253CA" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_2189_2689"
        x1="466.25"
        y1="18.0805"
        x2="469.61"
        y2="32.2005"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#3A82F6" />
        <stop offset="1" stopColor="#2253CA" />
      </linearGradient>
      <clipPath id="clip0_2189_2689">
        <rect width="501" height="48" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
